export interface VATTax {
  id?: string;
  name: string;                    // Tên loại thuế VAT (VD: "Thuế VAT đồ uống", "Thuế VAT hạt cà phê")
  rate: number;                    // Tỷ lệ thuế (VD: 8, 5, 10) - đơn vị %
  description?: string;            // Mô tả chi tiết
  applicableCategories: string[];  // Danh sách loại sản phẩm áp dụng (coffee, bottledDrink, dish)
  isActive: boolean;              // Trạng thái hoạt động
  isDefault?: boolean;            // Có phải là mức thuế mặc định
  effectiveDate?: Date;           // Ngày hiệu lực
  expiredDate?: Date;             // Ngày hết hiệu lực
  createdAt?: Date;
  updatedAt?: Date;
}

export interface VATTaxCreateInput {
  name: string;
  rate: number;
  description?: string;
  applicableCategories: string[];
  isActive?: boolean;
  isDefault?: boolean;
  effectiveDate?: Date;
  expiredDate?: Date;
}

export interface VATTaxUpdateInput extends Partial<VATTaxCreateInput> {
  id: string;
}

// Interface để áp dụng VAT cho sản phẩm
export interface ProductVAT {
  productId: string;
  productType: 'coffee' | 'bottledDrink' | 'dish';
  vatTaxId: string;
  vatRate: number;
  isOverride?: boolean;  // Có phải là thuế được ghi đè thủ công
}

// Enum cho các loại sản phẩm có thể áp dụng VAT
export enum ProductCategory {
  COFFEE = 'coffee',
  BOTTLED_DRINK = 'bottledDrink', 
  DISH = 'dish'
}

// Interface cho báo cáo thuế
export interface VATReport {
  period: {
    startDate: Date;
    endDate: Date;
  };
  summary: {
    totalRevenue: number;
    totalVATAmount: number;
    averageVATRate: number;
  };
  breakdown: Array<{
    vatTaxId: string;
    vatTaxName: string;
    vatRate: number;
    revenue: number;
    vatAmount: number;
    transactionCount: number;
  }>;
} 